const RECAPTCHA_V3_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;

const waitForRecaptcha = () => new Promise((resolve) => {
  if (window.grecaptcha) {
    resolve();
    return;
  }
  const interval = setInterval(() => {
    if (window.grecaptcha) {
      clearInterval(interval);
      resolve();
    }
  }, 100);
  setTimeout(() => {
    clearInterval(interval);
    resolve();
  }, 3000);
});

export const getCaptchaToken = async (action) => {
  if (process.env.REACT_APP_PRODUCTION !== 'TRUE') {
    return 'dev-bypass';
  }

  try {
    await waitForRecaptcha();
    if (!window.grecaptcha) {
      return null;
    }
    const token = await new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(RECAPTCHA_V3_SITE_KEY, { action })
          .then(resolve)
          .catch(() => resolve(null));
      });
    });
    return token;
  } catch (e) {
    return null;
  }
};
